import { combineReducers } from 'redux';

import AuthReducer from './AuthReducer';
import SidebarReducer from './SidebarReducer';
import TranslationReducer from './TranslationReducer';
import DispatcherReducer from './DispatcherReducer';
import DriversReducer from './DriversReducer';
import StatusesReducer from './StatusesReducer';
import BillingBatchReducer from './BillingBatchReducer';
import InsurancesReducer from './InsurancesReducer';

export default combineReducers({
  AuthReducer,
  SidebarReducer,
  TranslationReducer,
  DispatcherReducer,
  BillingBatchReducer,
  DriversReducer,
  StatusesReducer,
  InsurancesReducer,
  // reducers ...
});
